var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { effect: "dark", content: _vm.item.label, placement: "top" } },
    [
      _c(
        "div",
        {
          staticClass: "padding-5 pointer flex-center",
          on: { click: _vm.setTableBorder },
        },
        [
          _c("img", {
            style: {
              width: _vm.item.size + "px",
              height: _vm.item.size + "px",
            },
            attrs: { src: _vm.item.icon },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }